import { Injectable } from "@angular/core";
import * as RandomString from 'randomstring'

// import 'google-maps-api-typings';
import { createClient, GoogleMapsClient, GeocodingResponse } from '@google/maps';
import { Api } from './api';

@Injectable()
export class GoogleMapsService {

    private isReady: boolean = false;

    private readyCallbacks: Function[] = [];
    private initCallback: string = null;
    private key: string = 'AIzaSyAv6KHUeAyO_xWlBR4V7CSkW8WzGcGRTPQ';

    private apiClient: GoogleMapsClient;

    constructor(
        private api: Api,
    ) {

    }

    private addElementToHead(element: HTMLElement) {
        let head = document.getElementsByTagName('head').item(0);
        if (!head) return;
        head.appendChild(element);
    }

    public createScriptElement(): HTMLScriptElement {
        let src = new URL('https://maps.googleapis.com/maps/api/js');

        src.searchParams.append('key', this.key);
        src.searchParams.append('callback', this.initCallback);

        let script = document.createElement('script');
        script.src = src.href;

        return script;
    }

    public geocode(address: string): Promise<GeocodingResponse> {
        return new Promise((resolve, reject) => {
            this.api.postGeocode({
                address: address
            }).subscribe(success => {
                resolve(success);
            }, error => {
                reject(error);
            });
        })
    }

    public async geocodeToLatLng(address: string): Promise<google.maps.LatLng> {
        let response = await this.geocode(address);

        let results = response.results;
        if (!results || results.length <= 0) return null;
        let firstResult = results[0];

        let geometry = firstResult.geometry;
        if (!geometry) return null;

        let location = geometry.location;
        if (!location) return null;

        return new google.maps.LatLng(location.lat, location.lng);
    }

    public init() {
        this.apiClient = createClient({
            key: this.key
        });

        this.setUpInitCallback();

        let scriptElement = this.createScriptElement();

        this.addElementToHead(scriptElement);
    }

    private handleInitCallback() {
        this.isReady = true;

        for (let callback of this.readyCallbacks) {
            callback();
        }
    }

    private setUpInitCallback() {
        do {
            this.initCallback = 'initGoogleMaps_' + RandomString.generate(8);
        } while (window[this.initCallback] !== undefined);

        window[this.initCallback] = () => {
            this.handleInitCallback();
        }
    }

    public ready(callback: Function) {
        if (!this.isReady) {
            this.readyCallbacks.push(callback);
        } else {
            callback();
        }
    }

    public getUrlDirections(destination: google.maps.LatLng|string) {
        let url = `https://www.google.com/maps/dir/?api=1`;
        url += '&travelmode=driving';
        url += '&dir_action=navigate'; // show turn by turn navigation

        if (typeof destination == 'string') {
            url += `&destination=${destination}`
        } else {
            url += `&destination=${destination.lat()}/${destination.lng()}`;
        }

        return encodeURI(url);
    }

}



// WEBPACK FOOTER //
// ./src/providers/google-maps.ts